import React from "react";
import { useModal } from "../../../context/ModalContext";
import { MODALS } from "../../../config/params";
import { CloseIcon } from "../../../components/Icons";
import { StyledBookingFlowButton } from "../../containers/BookingScheduleContainer/BookingScheduleContainer.style";
import { MIXPANEL_EVENTS } from "../../../config/mixPanelEvents";
import { userActivityLogger } from "../../../utils/mixpanel";


const UpdatePaymentErrorModal = () => {
  const { openModal, closeModal } = useModal();
  const openContactModal = () => {
    userActivityLogger(MIXPANEL_EVENTS.CONTACT_HOSPITAL_TRIGGERED, {});
    openModal(MODALS.OVERDUE_CONTACT_MODAL);
  };
  const handleCancel = () => {
    closeModal();
  };

  return (
    <div className="flex flex-col w-full xl:w-[27rem]">
      <div className="flex justify-end cursor-pointer" onClick={handleCancel}>
        <CloseIcon/>
      </div>
      <div className="flex flex-col justify-between h-full">
        <div className="flex flex-col items-center h-full my-4">
          <img
            className="h-[9rem] w-[9rem]"
            alt="confirm_dropoff_icon"
            src="/assets/icons/account-alert.png"
          />
          <div className="text-2xl font-bold text-center">
          Call Hospital, unable to assign new card to plans
          </div>
          <div className="text-light-black text-center">
          We’re unable to assign your new card to your plans right now. Please contact your hospital for assistance.
          </div>
        </div>
        <div className="text-center">
          <StyledBookingFlowButton
            color="primary"
            size="small"
            className="w-full"
            onClick={openContactModal}
          >
              Contact Hospital
          </StyledBookingFlowButton>
        </div>
      </div>
    </div>
  );
};

export default UpdatePaymentErrorModal;
